import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import { Button, Input, Form, Card, message } from 'antd';
import axios from 'axios';
import agroboxImage from '../../assets/agrobox.png';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const { login } = useContext(LoginContext);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/usuarios/login`, {
        user: credentials.user,
        password: credentials.password,
      });
      const { usuario, token } = response.data;
      login({ user: usuario, token });
      
      if(response.data.usuario.tipoUsuario === 'administrador'){
        navigate('/');
      }else{
        navigate('/home-cliente');
      }
      

    } catch (error) {
      message.error('Credenciales incorrectas');
    }
  };

  return (
    <Card style={{ width: 300, margin: '100px auto' }}>
      <img src={agroboxImage} alt="Agrobox Logo" style={{ display: 'block', margin: '0 auto 20px', width: '150px', height: 'auto' }} />
      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input
            placeholder="Usuario"
            value={credentials.user}
            onChange={(e) => setCredentials({ ...credentials, user: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Input.Password
            placeholder="Contraseña"
            value={credentials.password}
            onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Iniciar sesión
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Login;